<template>
  <div class="no-coord-errors" v-show="errors.length">
    <el-tooltip
      v-for="(item, index) in errors"
      :key="index"
      :disabled="NO_PROMPT_TYPES.includes(item.errorType)"
      placement="top-start"
    >
      <template slot="content">
        系统检测此译文:
        <span v-for="(hint, index) in item.payload" :key="index">
          {{ hint }} ;&nbsp;
        </span>
      </template>
      <span :text="NO_COORD_ERROR_NAME[item.errorType]" />
    </el-tooltip>
  </div>
</template>

<script>
import { NO_COORD_ERROR_NAME, NO_PROMPT_TYPES } from '../const';

export default {
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      NO_COORD_ERROR_NAME,
      NO_PROMPT_TYPES
    };
  },
};
</script>

<style lang="scss" scoped>
.no-coord-errors {
  position: absolute;
  height: 17px;
  line-height: 17px;
  top: 20px;
  left: 15px;
  > span {
    display: inline-flex;
    align-items: center;
    margin-right: 4px;
    background: linear-gradient(
      90deg,
      rgba(247, 171, 159, 0.2) 0%,
      rgba(237, 114, 102, 0.3) 100%
    );
    border-radius: 4px;
    padding: 0 4px;
    color: #ed7266;
    &::before {
      content: attr(text);
      display: inline-block;
      font-size: 12px;
      transform: scale(0.85);
    }
  }
}
</style>
